export const environment = {
  production: false,
  development: true,
  environmentName: 'DEVELOPMENT',
  port: 4201, // npm run start:dev
  useEmulators: false, // Explicit: dev MUST hit real proporio-dev Firebase, never the emulator.
  firebase: {
    // TODO: Replace with your new dev Firebase project configuration
    apiKey: "AIzaSyBZA7inMIiPIA6CFSIDe-B-eT9b15XNmao",
    authDomain: "proporio-dev.firebaseapp.com",
    projectId: "proporio-dev",
    storageBucket: "proporio-dev.firebasestorage.app",
    messagingSenderId: "678031055488",
    appId: "1:678031055488:web:90408475ea7fc5d947e465",
    measurementId: "G-61LEE362L2",
    functionsRegion: "europe-west1", // Cloud Functions region
    // Web Push VAPID PUBLIC key of proporio-dev (generated 2026-08-07). Same
    // key as environment.ts because both point at the same project; it must
    // stay in step with the `messagingSenderId` above.
    vapidKey: "BNWMfbpQCtNUcmCAdJOqFwvD1lCVyaJL4l2FXRL3lhWMRdYqYaVoNgvAqmogGR3K17SQSeVRVMCz22S8pS5ISiA",
    // Firebase App Check — reCAPTCHA v3 (invisible). For VALID tokens on the
    // deployed dev site, add proporio-dev.web.app + proporio-dev.firebaseapp.com
    // to this reCAPTCHA key's domain list (propor.io only covers app.propor.io).
    appCheck: { recaptchaSiteKey: "6LeXRR0tAAAAAMP1IXye4p-Z6QmlIc3PTZw4A4GE" }
  },
  cockpitInboxDomain: 'dev-management.propor.io',
  marketingUrl: 'https://propor.io',
  // GA4 disabled outside production (empty id). See environment.prod.ts.
  analytics: {
    gaMeasurementId: ''
  },
  // Sentry (EU region), org `proporio-srl`, project `proporio-frontend`. The
  // SAME project as prod on purpose — the `environment` tag (set from
  // `environmentName` in core/observability/sentry.ts) is what separates them,
  // so filter on it before reading any issue. The DSN is public by design: it
  // only authorises POSTing events. Empty would mean the SDK never boots.
  sentry: {
    dsn: 'https://e5d602204e48baabe87ddbffb3f85fc2@o4511851361730560.ingest.de.sentry.io/4511851452104784',
    tracesSampleRate: 0
  },
  // PostHog (EU cloud), project 237335. The `phc_` token is a write-only
  // ingestion key — PostHog itself labels it "safe to use in public apps" — so
  // it belongs here next to the Firebase web config, not in Secret Manager.
  // GA4 stays off on dev, PostHog does not: that is what the independent
  // `enablePostHog` flag is for. See environment.prod.ts.
  posthog: {
    key: 'phc_BVuA5eersHjucC2npvmEQSgCFp2kPn53up6jHjCF3BjN',
    apiHost: 'https://eu.i.posthog.com'
  },
  api: {
    baseUrl: 'https://proporio-dev.firebaseapp.com/api',
    timeout: 10000
  },
  // Note: Google Maps API key and Stripe publishable key are served at runtime
  // via the `getPublicConfig` Cloud Function (Google Secret Manager).
  // Do NOT put secrets here — the bundle is public.
  features: {
    enableDebugMode: true,
    enableConsoleLogging: true,
    enablePerformanceMonitoring: false,
    enableAnalytics: false,
    enableErrorReporting: true,
    enablePostHog: true,
    requireSignupAccessCode: false,
    // Dormant until the verification e-mail flow is confirmed working here.
    enforceEmailVerificationWall: false,
    emailVerificationGraceHours: 48,
    // TEMPORAIRE — voir environment.interface.ts. Repasser à false pour
    // réactiver le flux de facturation à la création d'un bien.
    disablePropertyBillingConsent: true
  },
  cache: {
    ttl: 30000, // 30 seconds for development (shorter for testing)
    maxSize: 50
  },
  ui: {
    showDebugInfo: true,
    enableMockData: true,
    enableTestingTools: true
  }
}; 